export default {
  fetchLotesList: false,
  loteSelected: null,
  moSelected:null,
  formulationSelected:null,
  productsSelected:[],
  productSelected:null
};
